<template>
  <DBox
    :id="'cmp-settings-custom-texts-template-editor'"
    @add_click="onAddNewTemplate"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="$t('add_new') + ' ' + $t('custom_text')"
  >
    <div v-for="templ of templates" :key="templ.template_id">
      <table
        id="dtplugins-dbox_files"
        class="invcoie-line-list dbox1 dt-ntable dtplugins-dbox_files"
        style="
          --ntable-height: auto;
          --ntable-rowHeight: 32px;
          --ntable-header-height: 0px;
          --ntable-theadr-right: 0px;
        "
      >
        <tbody class="">
          <tr>
            <td class="name">
              <span
                ><strong>{{ templ.description }}</strong></span
              >
            </td>
            <td class="mail" style="max-width: 30px">
              <div class="dt-icon-container">
                <img
                  src="static/icons/minus/minus-gray.svg"
                  :alt="$t('hide_template')"
                  :title="$t('hide_template')"
                  class="dt-icon v5 s1"
                  @click.stop="(e) => onClickMinus(templ)"
                />
              </div>
            </td>
            <td class="options" style="max-width: 30px">
              <div class="dt-icon-container">
                <img
                  src="static/icons/delete.svg"
                  :alt="$t('delete') + ` ${templ.description}`"
                  :title="$t('delete') + ` ${templ.description}`"
                  class="dt-icon v5 s1"
                  @click.stop="(e) => onDeleteTemplate(templ)"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="ut-fc" v-show="!minusTemplateIDs.includes(templ.template_id)">
        <TextField2
          style="flex: 1"
          id="description"
          :placeholder="$t('descriptions')"
          :label="$t('descriptions')"
          :value="templ.description"
          @change="
            ({ name, value }) => onTemplateValueChange(name, value, templ)
          "
        />
        <TextField2
          style="flex: 1"
          id="subject"
          :placeholder="$t('email_subject')"
          :label="$t('email_subject')"
          :value="templ.subject"
          @change="
            ({ name, value }) => onTemplateValueChange(name, value, templ)
          "
        />
        <TextField2
          style="flex: 1"
          id="template_text"
          :placeholder="$t('body_text')"
          :label="$t('body_text')"
          textarea
          :height="200"
          :value="templ.template_text"
          @change="
            ({ name, value }) => onTemplateValueChange(name, value, templ)
          "
        />
      </div>
    </div>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";

import { openModalRoute } from "../../../../dt-plugins/modal/modal.mixin";
import { ConfirmationService } from "../../../../dt-plugins/confirmation/confirmation.service";
import {
  createTextFieldConfig,
  EventHooks,
} from "../../../../plugins/text-field";
import { capitalizeFirst } from "../../../../utility";

export default {
  components: {
    DBox,
  },
  props: ["custom_textsSettingsData", "template_key"],
  data: function () {
    return {
      // textFieldConfig: createTextFieldConfig({
      //   showEditIconOnHover: false,
      //   box: true,
      //   showValidationIcons: false,
      //   valueChangedEvent: EventHooks.OnBlur,
      // }),
      // datapoints_dict: {
      //   offer_mail_to_artist: `[% start_date %], [% booking_location_name %], [% city %], [% country %], [% first_offer_notes %], [% artist %], [% artist_stage %] [% performance_type %], [% event_name %], [% notes_ical %], [% line_up %], [% venue_name %], [% venue_address %], [% venue_city %], [% venue_postalcode %], [% venue_country %], [% venue_phone %], [% venue_email %], [% venue_url %], [% venue_capacity %], [% promoter_company_name %], [% promoter_representative %], [% promoter_address %], [% promoter_city %], [% promoter_postalcode %], [% promoter_state %], [% promoter_country %], [% promoter_phone %], [% promoter_mobile %], [% promoter_email %], [% promoter_vat_id %], [% promoter_url %], [% promoter_language %]`,
      //   request_form_mail: `[% request_link %]`,
      //   promoter_questionnaire_mail: `[% start_date %], [% booking_location_name %], [% city %], [% country %], [% venue_url %], [% venue_capacity %], [% artists %], [% questionnaire_link %]`,
      //   booking_document_and_files: `[% start_date %], [% booking_location_name %], [% city %], [% country %], [% venue_url %], [% venue_capacity %], [% artists %], [% documents %], [% invoices %], [% files %]`,
      // },
      minusTemplateIDs: [],
    };
  },
  watch: {
    custom_textsSettingsData: {
      immediate: true,
      handler: function (to, from) {
        if (to?.new_template_id) {
          this.$nextTick(() => {
            console.log(this.$refs[`${to.new_template_id}_description`]);
            this.$refs[`${to.new_template_id}_description`]?.[0]?.$el
              ?.querySelector("input")
              ?.focus();
          });
        }
      },
    },
  },
  computed: {
    templates: function () {
      return (
        this.custom_textsSettingsData?.[this.template_key]?.templates || []
      );
    },
    // datapoints: function () {
    //   return this.datapoints_dict[this.template_key];
    // },
  },
  methods: {
    onAddNewTemplate: function () {
      const lastTemplate = this.templates[this.templates.length - 1];
      let description, template_text;

      if (lastTemplate) {
        description = `${lastTemplate.description} Copy`;
        template_text = lastTemplate.template_text;
      } else {
        description = `New ${capitalizeFirst(this.template_key)}`;
        template_text = this.datapoints;
      }

      this.$emit("add_new", {
        template_key: this.template_key,
        description,
        template_text,
      });
    },
    onTemplateValueChange: function (name, value, item) {
      console.log({ item, name, value });
      this.$emit("updated", {
        item,
        name,
        value,
        template_key: this.template_key,
      });
    },
    onDeleteTemplate: function (template) {
      this.$emit("deleted", {
        template_key: this.template_key,
        template_id: template.template_id,
        description: template.description,
      });
    },
    onClickMinus: function (template) {
      if (this.minusTemplateIDs.includes(template.template_id)) {
        this.minusTemplateIDs = this.minusTemplateIDs.filter(
          (r) => r != template.template_id
        );
      } else {
        this.minusTemplateIDs = [
          ...this.minusTemplateIDs,
          template.template_id,
        ];
      }
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-settings-custom-texts-template-editor {
}
</style>
